import FJTextBasedEditingRightTimeLine from '../view/FJTextBasedEditingRightTimeLine';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionTimeLine from '../../../../redux/action/FJActionTimeLine';
import FJActionRightTextBaseEditing from '../../../../redux/action/textBasedEditing/FJActionRightTextBaseEditing.js';
const FJTextBasedEditingRightTimeLineContainer = () => {
    const dispatch = useDispatch();

    const thumbnailBlobUrl = useSelector(state => state.rightTextBaseEditing.thumbnailBlobUrl);
    const unitConversion = useSelector(state => state.timeLine.unitConversion);
    const totalTime = useSelector(state => state.timeLine.totalTime);
    const currentTime = useSelector(state => state.timeLine.currentTime);
    const splitTimeList = useSelector(state => state.rightTextBaseEditing.splitTimeList);
    const startTime = useSelector(state => state.rightTextBaseEditing.trimInfo.start);
    const selectTimeList = useSelector(state => state.rightTextBaseEditing.selectTimeList);
    const isPlaying = useSelector(state => state.rightTextBaseEditing.isPlaying);
    const sourceType = useSelector(state => state.rightTextBaseEditing.sourceType);

    const changeCurrentTime = useCallback(
        currentTime => {
            dispatch(FJActionRightTextBaseEditing.seekAction(currentTime));
        },
        [dispatch],
    );

    const updateUnitConversion = useCallback(
        (containerWidth, isResetUnitConversion = false) => {
            dispatch(FJActionTimeLine.updateUnitConversionAction(containerWidth, isResetUnitConversion));
        },
        [dispatch],
    );

    return (
        <FJTextBasedEditingRightTimeLine
            unitConversion={unitConversion}
            totalTime={totalTime}
            currentTime={currentTime}
            thumbnailBlobUrl={thumbnailBlobUrl}
            updateUnitConversion={updateUnitConversion}
            changeCurrentTime={changeCurrentTime}
            splitTimeList={splitTimeList}
            startTime={startTime}
            isPlaying={isPlaying}
            selectTimeList={selectTimeList}
            sourceType={sourceType}
        />
    );
};

export default FJTextBasedEditingRightTimeLineContainer;
